import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { getMediaUrlSelector, getSettingValueSelector, TargetSelector } from "@client/selectors";
import { type AppState, MediaType } from "@client/types";
import Component, { type AudioComponentProps } from "./component";

const makeMapStateToProps = () => {
  const audioFileSelector = getSettingValueSelector(TargetSelector.Entity, "audioFile");
  const fileUrlSelector = getMediaUrlSelector(audioFileSelector, MediaType.Audio);
  const audioSoundCloudIDSelector = getSettingValueSelector(TargetSelector.Entity, "audioSoundCloudID");

  return (state: AppState, props: RootContainerProps): AudioComponentProps => {
    return {
      ...props,
      audioFileUrl: fileUrlSelector(state, props),
      audioSoundCloudID: audioSoundCloudIDSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
